<!-- eslint-disable max-len -->
<style scoped></style>
<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive>
      <component :is="Component" v-if="route.meta?.keepAlive" :key="route.name" />
    </keep-alive>
    <component :is="Component" v-if="!route.meta?.keepAlive" :key="route.name" />
  </router-view>
</template>
<script setup>
import { onMounted } from 'vue'
import appStore from '@/store'
const { changePosition } = appStore.useTaskPosition
onMounted(() => {
  changePosition(50, 40)
})
</script>
